import { render, staticRenderFns } from "./ApplicationView.vue?vue&type=template&id=4dd54a48&scoped=true"
import script from "./ApplicationView.vue?vue&type=script&lang=js"
export * from "./ApplicationView.vue?vue&type=script&lang=js"
import style0 from "./ApplicationView.vue?vue&type=style&index=0&id=4dd54a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd54a48",
  null
  
)

export default component.exports